"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseAlignFromContent = exports.filterCreater = exports.parserCreater = void 0;
const eachLine_1 = __importDefault(require("../utils/eachLine"));
const constants_1 = require("./constants");
const number_1 = require("../utils/number");
const array_1 = require("../utils/array");
const checkTypeByHeadLines_1 = require("../checkType/checkTypeByHeadLines");
const error_1 = require("../utils/error");
const parserCreater = (parserOpt, fileName) => (line) => {
    line = line.trim();
    if (!parserOpt)
        return null;
    const { split, columns } = parserOpt;
    const items = line.split(split);
    const alignment = {
        ctg1: '',
        start1: 0,
        end1: 0,
        ctg2: '',
        start2: 0,
        end2: 0,
        alignLen: 0,
        color: constants_1.DEFAULT_COLOR_FLAG,
        opacity: constants_1.DEFAULT_OPACITY_FLAG,
    };
    const alignLens = [];
    let shouldReverse = false;
    for (const index in parserOpt.columns) {
        const colum = columns[index];
        const value = items[index];
        if (['ctg1', 'ctg2'].includes(colum)) {
            alignment[colum] = value;
        }
        else if ([
            'start1',
            'end1',
            'start2',
            'end2',
            'identity',
            'evalue',
            'bitScore',
            'len1',
            'len2',
        ].includes(colum)) {
            if (!(0, number_1.isNumber)(value)) {
                const errorInfo = (0, error_1.errorPos)(line, items, index);
                throw new Error(`${colum} should be a number, but get '${value}' in '${fileName}': \n${errorInfo} \n`);
            }
            alignment[colum] = Number(value);
        }
        else if (colum === 'alignLen') {
            (0, number_1.isNumber)(value) && alignLens.push(Number(value));
        }
        else if (colum === 'color:opacity' && value) {
            const [color, opacity] = value.split(':');
            alignment.color = color;
            alignment.opacity = (0, number_1.isNumber)(opacity) ? Number(opacity) : 1;
        }
        else if (colum === 'minimapStrand' && value === '-') {
            shouldReverse = true;
        }
    }
    if (shouldReverse) {
        const { start1, end1 } = alignment;
        [alignment.start1, alignment.end1] = [end1, start1];
    }
    if (alignLens.length > 0)
        alignment.alignLen = (0, array_1.average)(alignLens);
    if (alignment.alignLen === 0) {
        const { start1, end1, start2, end2 } = alignment;
        alignment.alignLen =
            (Math.abs(start1 - end1) + 1 + Math.abs(start2 - end2) + 1) / 2;
    }
    return alignment;
};
exports.parserCreater = parserCreater;
const filterCreater = (parserOptFilters) => (line) => {
    line = line.trim();
    let filterCondition = line === '' || line.startsWith('#');
    if (parserOptFilters)
        filterCondition =
            filterCondition ||
                parserOptFilters.findIndex((lineCharacteristic) => (0, checkTypeByHeadLines_1.checkLine)(line, lineCharacteristic)) >= 0;
    return filterCondition;
};
exports.filterCreater = filterCreater;
const parseAlignFile = (fileName, parser, filter, filterAlign = null) => {
    const alignments = [];
    const alignmentsByCtgs = {};
    const lenInfo = {};
    return (0, eachLine_1.default)(fileName, (line) => {
        const alignment = parser(line);
        if (alignment) {
            const { len1, len2, ctg1, ctg2 } = alignment;
            if (len1)
                lenInfo[ctg1] = len1;
            if (len2)
                lenInfo[ctg2] = len2;
            delete alignment.len1;
            delete alignment.len2;
            if (!(ctg1 in alignmentsByCtgs))
                alignmentsByCtgs[ctg1] = {};
            if (!(ctg2 in alignmentsByCtgs[ctg1]))
                alignmentsByCtgs[ctg1][ctg2] = [];
            if (!(ctg2 in alignmentsByCtgs))
                alignmentsByCtgs[ctg2] = {};
            if (!(ctg1 in alignmentsByCtgs[ctg2]))
                alignmentsByCtgs[ctg2][ctg1] = [];
            alignment &&
                (filterAlign ? !filterAlign(alignment) : true) &&
                alignments.push(alignment) &&
                alignmentsByCtgs[ctg1][ctg2].push(alignment) &&
                alignmentsByCtgs[ctg2][ctg1].push(alignment);
        }
        return true;
    }, filter).then(() => {
        return { alignments, alignmentsByCtgs, lenInfo };
    });
};
const parseAlignFromContent = (content, parser, filter, filterAlign = null) => {
    const alignments = [];
    const alignmentsByCtgs = {};
    const lenInfo = {};
    const lines = content.trim().split('\n');
    lines.forEach((line) => {
        if (filter(line))
            return;
        const alignment = parser(line);
        if (alignment) {
            const { len1, len2, ctg1, ctg2 } = alignment;
            if (len1)
                lenInfo[ctg1] = len1;
            if (len2)
                lenInfo[ctg2] = len2;
            delete alignment.len1;
            delete alignment.len2;
            if (!(ctg1 in alignmentsByCtgs))
                alignmentsByCtgs[ctg1] = {};
            if (!(ctg2 in alignmentsByCtgs[ctg1]))
                alignmentsByCtgs[ctg1][ctg2] = [];
            if (!(ctg2 in alignmentsByCtgs))
                alignmentsByCtgs[ctg2] = {};
            if (!(ctg1 in alignmentsByCtgs[ctg2]))
                alignmentsByCtgs[ctg2][ctg1] = [];
            alignment &&
                (filterAlign ? !filterAlign(alignment) : true) &&
                alignments.push(alignment) &&
                alignmentsByCtgs[ctg1][ctg2].push(alignment) &&
                alignmentsByCtgs[ctg2][ctg1].push(alignment);
        }
    });
    return { alignments, alignmentsByCtgs, lenInfo };
};
exports.parseAlignFromContent = parseAlignFromContent;
exports.default = parseAlignFile;
__exportStar(require("./constants"), exports);
